import type { ViewProps } from "tamagui";

import { TextAttributesMapper } from "@/ui/core/Text";
import type { InputProps } from "@/ui/theme/tamagui.config";
import { ColorToken } from "@/ui/theme/tokens";

const LiveEventHeaderHeight = 120;

const GreetingCardHeight = 216;

const IllustrationSize = {
  Card: 40,
  Modal: 56,
  PreviewCard: 36,
  UpcomingEvents: 46,
  Weight: 46,
} as const;

const MessageWidthBreakpoint = {
  Large: 1200,
  Medium: 768,
} as const;

// below this viewport width, the custom WebTabBar overflows off-screen making some tabs unreachable, so we
// fall back to the native-style tab bar (which shrinks its columns to fit any width, like the mobile app).
const WebTabBarMinWidth = 768;

const IntercomWidget = {
  // passed to the intercom init settings
  HorizontalPadding: 20,
  // hardcoded observed width; if intercom widget width ever changes this needs to be updated
  Width: 60,
} as const;

const MessageWidthPercentage = {
  Large: "25%",
  Medium: "50%",
  Small: "80%",
} as const;

const AnimationDuration = {
  Default: 300,
  FadeMobile: 150,
  FadeWeb: 100,
  ImageTransition: 200,
  ModalDismiss: 600,
} as const;

enum ToastAnimation {
  TranslateY = -50,
}

const InputTextStyles = TextAttributesMapper.body;

const TextAreaDefaultHeight = 147;

const InputFieldBaseStyles = {
  backgroundColor: ColorToken.NeutralBackgroundPrimary,
  borderColor: ColorToken.NeutralTertiary,
  borderRadius: 12,
  borderWidth: 1,
  height: 46,
  paddingHorizontal: 12,
  paddingVertical: 12,
  width: "auto",
} satisfies ViewProps;

const TextInputBaseStyles = {
  ...InputFieldBaseStyles,
  color: ColorToken.NeutralPrimary,
  fontFamily: InputTextStyles.fontFamily,
  fontSize: InputTextStyles.fontSize,
  letterSpacing: InputTextStyles.letterSpacing,
  maxFontSizeMultiplier: InputTextStyles.maxFontSizeMultiplier,
  paddingVertical: 10,
} satisfies InputProps;

// Full opacity (FF) ensures toolbar background matches bottom sheet
const KeyboardToolbarOpacity = "FF";

export {
  AnimationDuration,
  GreetingCardHeight,
  IllustrationSize,
  InputFieldBaseStyles,
  IntercomWidget,
  KeyboardToolbarOpacity,
  LiveEventHeaderHeight,
  MessageWidthBreakpoint,
  MessageWidthPercentage,
  TextAreaDefaultHeight,
  TextInputBaseStyles,
  ToastAnimation,
  WebTabBarMinWidth,
};
